import { Outlet, useLocation } from "react-router-dom"
import { usePageWrapper } from "../../../hooks"
import { Box } from "@mui/material"
import { ArtTabs } from "@art/shared-ui"
import { useAttributePermission } from "../../permissions"

const GeneralPlanSettings = () => {

    const location = useLocation();
    const canViewBilling = useAttributePermission("PLATFORM_SETTINGS", "BILLING_USAGE", "ViewBilling");
    const canManageAddons = useAttributePermission("PLATFORM_SETTINGS", "BILLING_USAGE", "ManageAddons");
    const canManageBillingDetails = useAttributePermission("PLATFORM_SETTINGS", "BILLING_USAGE", "ManageBillingDetails");
    
    return <div>
        <ArtTabs tabs={[
            ...(canViewBilling ? [{
                label: "Overview",
                route: "/platform-settings/billing/overview"
            }] : []),
            ...(canManageAddons ? [{
                label: "Add-ons",
                route: "/platform-settings/billing/addons"
            }] : []),
            ...(canManageBillingDetails ? [{
                label: "Billing Details",
                route: "/platform-settings/billing/details"
            }] : []),
        ]}
        currentPath={location.pathname}
        />

        <Box sx={{py: '30px'}}>
            <Outlet />
        </Box>

    </div>
}

export default usePageWrapper(GeneralPlanSettings, {
    page_title: "Billing & Subscription"
})
